<section class="section section--testimonial" aria-labelledby="testimonial-title">
  <div class="wrap readable">
    <p class="eyebrow">Testimonials</p>
    <h2 class="title" id="testimonial-title">Built for Real Coaching Programmes</h2>
    <blockquote>
      <i
        >The Wheel fits beautifully into my program and gives me a structured way help my coaching clients with values alignment. It’s
        already helping me guide conversations that are more grounded and purposeful.</i
      ><br />
    </blockquote>
    <span
      ><b>Michele, coach & program creator of <a href="https://mahjlife.com/">mahjlife.com</a></b></span
    >
  </div>
</section>
<section class="section section--pricing" aria-labelledby="pricing-title">
  <div class="wrap pricing-layout">
    <div class="readable">
      <p class="eyebrow">Pricing</p>
      <div class="price-block"><strong>$650</strong><span>for the first assessment wheel</span></div>
      <div class="additional-price">$50 for each additional wheel</div>
    </div>
    <div class="pricing-scope">
      <div>
        <h3>Included</h3>
        <p>
          Supplied-content configuration, installation on one approved website, dedicated page, downloadable result image,
          responsive/installation checks, and two revision rounds.
        </p>
      </div>
      <p class="scope-note">
        <strong>Scoped separately:</strong> Email delivery, participant data storage, custom integrations, additional websites, and
        materially different user flows are reviewed and quoted separately.
      </p>
    </div>
  </div>
</section>
